import React from 'react';
import Editor from '@monaco-editor/react';

export default function SqlMonacoEditor({ value, onChange, height = 300 }) {
    return (
        <Editor
            height={height}
            language="sql"
            theme="vs-light"
            value={value}
            onChange={v => onChange(v ?? '')}
            options={{
                minimap: { enabled: false },
                fontSize: 13,
                lineNumbers: 'on',
                scrollBeyondLastLine: false,
                wordWrap: 'on'
            }}
        />
    );
}
